import TileGridContainer from 'features/tiles/tileGridContainer';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { RootState } from 'app/store';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Spinner from 'common/components/loading/spinner';
import { useGetWebhookHistoriesQuery } from 'app/apis/queryApi';
import { useMemo } from 'react';
import WebhookHistoryTable from 'features/webhooks/webhook-history-table/webhook-history-table';

const SettingsWebhookHistoryPage = () => {
  const { siteId } = useSelector((state: RootState) => state.selectedSite);
  const { webhookId } = useParams();

  const webhookIdNotNull = useMemo(() => webhookId ?? '', [webhookId]);

  const { data: webhookHistoryResult, isLoading: isFetchingWebhookHistories } =
    useGetWebhookHistoriesQuery({
      siteId,
      webhookId: webhookIdNotNull
    });

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full grow basis-full">
        <section className="mx-6 my-6">
          <div className="flex items-center justify-between border-b border-neutral-200 pb-4 mb-4 mt-2">
            <h2 className="text-primary-700 text-l">Webhook History</h2>
          </div>

          {isFetchingWebhookHistories ? (
            <div className="flex justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              {webhookHistoryResult &&
              webhookHistoryResult.webhookHistories.length > 0 ? (
                <WebhookHistoryTable
                  webhookHistories={webhookHistoryResult.webhookHistories}
                />
              ) : (
                <div>
                  <i className="ra-icons-generic-spanner-wrench text-neutral-500 text-4xl text-center block"></i>
                  <h2 className="text-center text-xl">No Webhook History</h2>
                  <p className="text-center mt-1 text-sm">
                    This webhook has no event history.
                  </p>
                </div>
              )}
            </>
          )}
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};

export default SettingsWebhookHistoryPage;
